<template><div><h1>VUX V2.5.2 发布日志</h1>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] 在 `on-change` 事件之前 emit `input` 事件</li>
<li>[feature] `options` 中增加 `inlineDesc` 属性</li>
</ul>
<h2><a href="/zh-CN/components/inline-x-number.html">InlineXNumber</a></h2>
<ul><li>[feature] 单独的 inline-x-number 组件可以正常使用了</li>
</ul>
<h2><a href="/zh-CN/components/panel.html">Panel</a></h2>
<ul><li>[feature] 增加type类型(4,5)和描述信息(来源,时间和其他自定义信息)</li>
</ul>
<h2><a href="/zh-CN/components/popup-header.html">PopupHeader</a></h2>
<ul><li>[feature] 新组件 popup-header, 配合 popup 使用统一头部样式</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 支持弹窗样式设置 prop:popup-style #1656</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[feature] 支持弹窗样式设置 prop:popup-style #1656</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持弹窗样式设置 prop:popup-style #1656</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.2-246.vue?44f36751